import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';
import { FC } from 'react';

import { ReactComponent as MessageIcon } from '../../../assets/icons/message.svg';

const useStyles = makeStyles((theme) => ({
  supportBoxHeader: {
    fontWeight: 600,
    fontSize: '18px',
    marginTop: '20px',
    marginBottom: '25px',
    lineHeight: '21.09px',
    letterSpacing: '0.1px',
  },
  supportBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    width: 'max-content',
    height: '70px',
    padding: '25px',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  supportBoxText: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21.09px',
    letterSpacing: '0.1px',
  },
  msgIcon: {
    marginLeft: '20px',
    fill: theme.palette.text.secondary,
  },
}));

export const ContactSupport: FC = () => {
  const classes = useStyles();

  const contactSupport = () => {
    const supportEmail = 'support@halterix.com';
    window.location.href = `mailto:${supportEmail}`;
  };

  return (
    <Grid item xs={2}>
      <Typography className={classes.supportBoxHeader}>Support</Typography>
      <Paper className={classes.supportBox} onClick={contactSupport}>
        <Typography className={classes.supportBoxText}>
          Contact Tech Support
        </Typography>
        <SvgIcon className={classes.msgIcon} component={MessageIcon} />
      </Paper>
    </Grid>
  );
};
